import React from 'react'
import { useCheckout } from 'lib/modules/checkout'
import { Container } from './styled'

interface Props {
  onChange?: (value: boolean) => void
}

export const UseShippingAddress = ({ onChange }: Props) => {
  const { billingAddress, useShippingAddress } = useCheckout()
  const { setUseSameAsShipping } = useSameAsShipping()

  return (
    <Container
      isFetching={billingAddress.isFetching}
    >
      <label>
        <input
          type='checkbox'
          checked={useShippingAddress}
          onChange={(e) => {
            const value = e.target.checked
            setUseSameAsShipping(value)
            onChange?.(value)
          }}
          disabled={billingAddress.isFetching}
        />
        <span>
          Same as Shipping Address
        </span>
      </label>
    </Container>
  )
}

export const useSameAsShipping = () => {
  const { setBillingAddressSameAsShipping } = useCheckout()

  return {
    setUseSameAsShipping: (value: boolean) => {
      setBillingAddressSameAsShipping({ value })
    }
  }
}
